import { useQuery } from '@tanstack/react-query'
import { Alert, Button, Skeleton } from 'antd'
import { useTRPC } from '@/trpc/react.ts'
import { GroupBillsTable } from './group-bills-table.tsx'

export function GroupExpandedBills({ groupId, onBill }: { groupId: number; onBill: (id: number) => void }) {
  const trpc = useTRPC()
  const query = useQuery(trpc.bill.groupDetail.queryOptions({ groupId }))
  if (query.isPending) {
    return <Skeleton active paragraph={{ rows: 3 }} />
  }
  if (query.isError) {
    return (
      <Alert
        showIcon
        type="error"
        title={query.error.message}
        action={<Button onClick={() => void query.refetch()}>重试</Button>}
      />
    )
  }
  return (
    <section aria-label="组内账单明细" className="bg-surface rounded-lg p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold">组内账单</h3>
        <span className="text-content-muted text-xs">共 {query.data.items.length} 笔 · 点击账单号查看详情</span>
      </div>
      <GroupBillsTable items={query.data.items} onBill={onBill} scrollHeight="20rem" />
    </section>
  )
}
